export default {
  // Bind props
  props: {
    title: { required: true, type: String },
    text: { required: true, type: String },
    alertClass: { default: 'alert-info', type: String },
  },
}
